import { render } from "./ClubOptions.vue?vue&type=template&id=0abb25e5&scoped=true"
import script from "./ClubOptions.vue?vue&type=script&lang=js"
export * from "./ClubOptions.vue?vue&type=script&lang=js"

import "./ClubOptions.vue?vue&type=style&index=0&id=0abb25e5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abb25e5"]])

export default __exports__